import { render, staticRenderFns } from "./deleteMarketSegment.vue?vue&type=template&id=1e18978d"
import script from "./deleteMarketSegment.vue?vue&type=script&lang=js"
export * from "./deleteMarketSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports